import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";

function RunbookGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (props.filter) {
      setSearchText(props.filter.runbookName ?? "");
    }
  }, [props.filter?.runbookName]);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      GridHelper.handleSearch({ runbookName: searchText }, location, navigate);
    }
  };

  const handleSearch = () => {
    GridHelper.handleSearch({ runbookName: searchText }, location, navigate);
  };

  const handleClear = () => {
    setSearchText("");
    props.onClearFilters();
  };

  return (
    <div className="mb-3" data-tour="filter-section">
      <InputGroup>
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search runbooks by name or description..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={onKeyDown}
        />
        {searchText && (
          <Button variant="outline-secondary" onClick={handleClear}>
            <FaTimes />
          </Button>
        )}
        <Button variant="primary" onClick={handleSearch}>
          Search
        </Button>
      </InputGroup>
    </div>
  );
}

export default RunbookGridFilter;
